"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Facebook({ color = '#7f58af', size = 80, className, style, ...rest }) {
    const circles = [...Array(3)].map((_, index) => ((0, jsx_runtime_1.jsx)("div", { style: { background: `${color}` } }, index)));
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-facebook'], className), style: { width: size, height: size, ...style }, ...rest, children: circles }));
}
exports.Facebook = Facebook;
//# sourceMappingURL=facebook.js.map